import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { emojiBaseUrl, emojiMap, emojiList } from '../util';
import { isMobile } from '../../../utils/environment';
import SvgIcon from '../../common/base/SvgIcon.vue';
import EmojiIcon from '../../common/icons/EmojiIcon.vue';
import '../../../directives/vClickOutside';


export default /*#__PURE__*/_defineComponent({
  __name: 'emojiPC',
  emits: ['choose-emoji'],
  setup(__props, { emit }) {


const showEmojiToolbar = ref(false);
const chooseEmoji = (itemName: string) => {
  const emojiInfo = itemName;
  emit('choose-emoji', emojiInfo);
};
const handleEmojiToobar = () => {
  showEmojiToolbar.value = !showEmojiToolbar.value;
};
const handleClickOutsideEmojiToobar = () => {
  if (showEmojiToolbar.value) {
    showEmojiToolbar.value = false;
  }
};

return { __sfc: true,emit, showEmojiToolbar, chooseEmoji, handleEmojiToobar, handleClickOutsideEmojiToobar, emojiBaseUrl, emojiMap, emojiList, isMobile, SvgIcon, EmojiIcon }
}

})